const afMessages = {
  /* 01.General */

  "main.name": "Naam",
  "main.sentiment": "Gevoel",
  "main.urgency": "Dringendheid",
  "main.language": "Taal",
  "main.agent": "Agent",
  "main.property_name": "Eiendom se naam",
  "main.booking_number": "Besprekingsnommer",
  "main.check_out": "Uitklok",
  "main.check_in": "Inklok",
  "main.adults": "Volwassenes",
  "main.corporate_code": "Maatskappykode",
  "main.group_code": "Groepkode",
  "main.promo_code": "Promosiekode",
  "main.ai_response": "KI-antwoord",
  "main.template_response": "Sjabloonantwoord",
  "main.converttoticket": "Skakel om na kaartjie",
  "main.switch_property": "Verander eiendom",
  "main.Group_id": "Groep-ID",
  "main.integration_id": "Integrasie-ID",
  "main.submit": "Dien in",
  "main.cancel": "Kanselleer",
    "main.select_template": "Kies 'n sjabloon",
  "main.rooms": "Kamers",
  "main.rates": "Tariewe",

  //footer
   "footer.knowledge": "Kennis",
  "footer.home": "Tuis",
  "footer.help": "Hulp",

  //ticket
  "ticket.thank_you": "Dankie dat u die vorm ingedien het",
  "ticket.ticket": "Kaartjie",
  "ticket.details": "Vul asseblief die vorm in wat die besonderhede van die kaartjie beskryf.",
  "ticket.select_category": "Kies Kategorie",
  "ticket.category": "Kategorie",
  "ticket.title": "Titel",
  "ticket.notes": "Notas",
  "ticket.status": "Status",
  "ticket.assigned_to": "Toegewys aan",
  "ticket.submit_form": "Dien Vorm In",

  
  "main.total": "Totaal",
  "main.pastetooutlook": "Plak na Outlook",
  "main.children": "Kinders",
  "main.promocode": "Promosie-/Maatskappy-/Groepkode",
  "main.exact_match_only": "Slegs presiese ooreenkoms",
  "main.search": "Soek",
  "main.no_rate_match": "Geen tariewe stem ooreen met jou keuse nie. Wysig jou soektog en probeer weer.",
  "main.translate_to": "Vertaal na",
  "main.regenerate": "Genereer weer",
  "main.copy_text": "Kopieer teks",
  "main.additional_instructions": "Bykomende instruksies",

  "faq.helpcenter": "Hulpsentrum",
  "faq.reply.email.sabre.question": "Hoe antwoord ek 'n e-pos met Aven Hospitality Concierge Email Automation?",
  "faq.reply.email.sabre.answer": "Maak die e-pos oop en begin die Aven Hospitality-byvoeging. Jy kan kies tussen drie opsies: gebruik 'n voorafbepaalde sjabloon, genereer 'n KI-antwoord, of omskep die e-pos in 'n kaartjie. Kies die beste opsie, hersien die antwoord, maak veranderinge indien nodig en stuur dit direk vanaf Outlook.",

  "faq.rates.availability.question": "Hoe voeg ek tariewe, beskikbaarheid en kamerbesonderhede by my antwoord?",
  "faq.rates.availability.answer": "Gebruik die + Rates-funksie om gastebesonderhede soos datums en aantal gaste in te voer. Concierge sal akkurate beskikbaarheid en pryse by jou antwoord voeg. Jy kan ook + Rooms gebruik om kamerbeskrywings en beelde by te voeg.",

  "faq.different.language.question": "Wat moet ek doen as die e-pos in 'n ander taal is?",
  "faq.different.language.answer": "Aven Hospitality Concierge laat jou toe om inkomende e-posse na jou voorkeurtaal te vertaal.",

  "faq.pin.addin.question": "Hoe verseker ek dat die byvoeging altyd beskikbaar is in Outlook?",
  "faq.pin.addin.answer": "Speld die Aven Hospitality Concierge-byvoeging vas in Outlook om dit altyd sigbaar te hou.",

  "faq.knowledge.hub.question": "Wat is die Knowledge Hub-soekopsie?",
  "faq.knowledge.hub.answer": "Knowledge Hub-soektog help jou om eiendomspesifieke inligting vinnig binne Outlook te vind.",

  "faq.reply.email.myma.question": "Hoe antwoord ek 'n e-pos met Myma?",
  "faq.reply.email.myma.answer": "Maak die e-pos oop en begin die Myma-byvoeging. Jy kan 'n sjabloon gebruik, 'n KI-antwoord genereer of die e-pos na 'n kaartjie omskep.",

  "faq.room.details.question": "Hoe voeg ek kamerbesonderhede by my antwoord?",
  "faq.room.details.answer": "Gebruik + Rooms om kamerbeskrywings en beelde by te voeg.",

  "faq.myma.different.language.question": "Wat moet ek doen as die e-pos in 'n ander taal is?",
  "faq.myma.different.language.answer": "Myma laat jou toe om inkomende e-posse na jou voorkeurtaal te vertaal.",

  "faq.myma.pin.addin.question": "Hoe verseker ek dat die byvoeging altyd beskikbaar is in Outlook?",
  "faq.myma.pin.addin.answer": "Speld die Myma-byvoeging vas in Outlook sodat dit outomaties met elke e-pos oopmaak.",

};
export default afMessages;